import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

const DesktopMenu = () => {
  return (
    <Nav aria-label="Primary">
      <MenuList>
        <MenuItem>
          <MenuLink to="/about" end>
            ABOUT
          </MenuLink>
        </MenuItem>

        <MenuItem>
          <MenuLink to="/self-hypnosis">
            SELF HYPNOSIS
          </MenuLink>
        </MenuItem>

        <MenuItem>
          <MenuLink to="/hypnotherapy">
            HYPNOTHERAPY
          </MenuLink>
        </MenuItem>

        <MenuItem>
          <MenuLink to="/group-hypnosis">
            GROUP HYPNOSIS
          </MenuLink>
        </MenuItem>
      </MenuList>
    </Nav>
  );
};

const Nav = styled.nav`
  display: none;

  @media (min-width: 1000px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    width: 320px;
    min-width: 320px;

    padding: 18px 12px;
    position: sticky;
    top: 10px;
    height: fit-content;
  }
`;

const MenuList = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const MenuItem = styled.li`
  width: 100%;
`;

/**
 * Matches the mobile menu “pill” style:
 * - calm ink text
 * - soft pink hover wash
 * - green active wash
 */
const MenuLink = styled(NavLink)`
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  padding: 14px 16px;
  border-radius: 999px;

  font-family: var(--font-heading), sans-serif;
  font-weight: 800;
  letter-spacing: 0.02em;
  font-size: 1.15rem;
  line-height: 1.1;

  color: var(--ink);

  background: transparent;
  border: 1px solid transparent;

  transition: background 160ms ease, border-color 160ms ease, transform 160ms ease;

  &:hover {
    background: rgba(255, 119, 200, 0.12);
    border-color: var(--border);
    transform: translateY(-1px);
  }

  &.active {
    background: rgba(43, 189, 95, 0.10);
    border-color: var(--border);
  }

  &::after {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 99px;
    margin-left: 10px;
    background: transparent;
    transition: background 160ms ease;
  }

  &:hover::after {
    background: var(--brand-pink);
  }

  &.active::after {
    background: var(--brand-green);
  }
`;

export default DesktopMenu;
